require.register("documenteditor/controllers/commentsCtrl", function(exports, require, module){
  $0
  
});

